import { isAllReadApi } from "@/api/app";
export default {
  namespaced: true,
  state: {
    isAllRead: true
  },
  mutations: {
    changeReadStatus: function changeReadStatus(state, data) {
      state.isAllRead = data;
    }
  },
  actions: {
    getReadStatus: function getReadStatus(_ref) {
      var commit = _ref.commit;
      isAllReadApi().then(function (res) {
        if (res.code == "000000") {
          commit("changeReadStatus", res.data);
        }
      });
    }
  }
};